import { render, staticRenderFns } from "./categories.vue?vue&type=template&id=676d3768&"
import script from "./categories.vue?vue&type=script&lang=js&"
export * from "./categories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('676d3768')) {
      api.createRecord('676d3768', component.options)
    } else {
      api.reload('676d3768', component.options)
    }
    module.hot.accept("./categories.vue?vue&type=template&id=676d3768&", function () {
      api.rerender('676d3768', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/categories.vue"
export default component.exports